/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  LazyMintERC1155,
  LazyMintERC1155Interface,
} from "../LazyMintERC1155";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_contractURI",
        type: "string",
      },
      {
        internalType: "address payable",
        name: "_controlCenter",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nativeTokenWrapper",
        type: "address",
      },
      {
        internalType: "address",
        name: "_saleRecipient",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_royaltyBps",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "_feeBps",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "claimConditionIndex",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "claimer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantityClaimed",
        type: "uint256",
      },
    ],
    name: "ClaimedTokens",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "startTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "LazyMintedTokens",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "startTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxClaimableSupply",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "supplyClaimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantityLimitPerTransaction",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "waitTimeInSecondsBetweenClaims",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "merkleRoot",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
        ],
        indexed: false,
        internalType: "struct ILazyMintERC1155.ClaimCondition[]",
        name: "claimConditions",
        type: "tuple[]",
      },
    ],
    name: "NewClaimConditions",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "prevOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "NewOwner",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isDefaultRecipient",
        type: "bool",
      },
    ],
    name: "NewSaleRecipient",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newFeeBps",
        type: "uint256",
      },
    ],
    name: "PrimarySalesFeeUpdates",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newRoyaltyBps",
        type: "uint256",
      },
    ],
    name: "RoyaltyUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "restricted",
        type: "bool",
      },
    ],
    name: "TransfersRestricted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NATIVE_TOKEN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TRANSFER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "burnBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantity",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "_proofs",
        type: "bytes32[]",
      },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "claimConditions",
    outputs: [
      {
        internalType: "uint256",
        name: "totalConditionCount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timstampLimitIndex",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultSaleRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeBps",
    outputs: [
      {
        internalType: "uint120",
        name: "",
        type: "uint120",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_index",
        type: "uint256",
      },
    ],
    name: "getClaimConditionAtIndex",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "startTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxClaimableSupply",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "supplyClaimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantityLimitPerTransaction",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "waitTimeInSecondsBetweenClaims",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "merkleRoot",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
        ],
        internalType: "struct ILazyMintERC1155.ClaimCondition",
        name: "mintCondition",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "getIndexOfActiveCondition",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_index",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_claimer",
        type: "address",
      },
    ],
    name: "getTimestampForNextValidClaim",
    outputs: [
      {
        internalType: "uint256",
        name: "nextValidTimestampForClaim",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_baseURIForTokens",
        type: "string",
      },
    ],
    name: "lazyMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nativeTokenWrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextTokenIdToMint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "royaltyBps",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "saleRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "startTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxClaimableSupply",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "supplyClaimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantityLimitPerTransaction",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "waitTimeInSecondsBetweenClaims",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "merkleRoot",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
        ],
        internalType: "struct ILazyMintERC1155.ClaimCondition[]",
        name: "_conditions",
        type: "tuple[]",
      },
    ],
    name: "setClaimConditions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_saleRecipient",
        type: "address",
      },
    ],
    name: "setDefaultSaleRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_feeBps",
        type: "uint256",
      },
    ],
    name: "setFeeBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_restrictedTransfer",
        type: "bool",
      },
    ],
    name: "setRestrictedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_royaltyBps",
        type: "uint256",
      },
    ],
    name: "setRoyaltyBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_saleRecipient",
        type: "address",
      },
    ],
    name: "setSaleRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "_tokenURI",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transfersRestricted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "startTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxClaimableSupply",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "supplyClaimed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantityLimitPerTransaction",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "waitTimeInSecondsBetweenClaims",
            type: "uint256",
          },
          {
            internalType: "bytes32",
            name: "merkleRoot",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "pricePerToken",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
        ],
        internalType: "struct ILazyMintERC1155.ClaimCondition[]",
        name: "_conditions",
        type: "tuple[]",
      },
    ],
    name: "updateClaimConditions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "_tokenURI",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_claimer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantity",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "_proofs",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "_conditionIndex",
        type: "uint256",
      },
    ],
    name: "verifyClaim",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type LazyMintERC1155ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: LazyMintERC1155ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class LazyMintERC1155__factory extends ContractFactory {
  constructor(...args: LazyMintERC1155ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _contractURI: string,
    _controlCenter: string,
    _trustedForwarder: string,
    _nativeTokenWrapper: string,
    _saleRecipient: string,
    _royaltyBps: BigNumberish,
    _feeBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<LazyMintERC1155> {
    return super.deploy(
      _contractURI,
      _controlCenter,
      _trustedForwarder,
      _nativeTokenWrapper,
      _saleRecipient,
      _royaltyBps,
      _feeBps,
      overrides || {}
    ) as Promise<LazyMintERC1155>;
  }
  getDeployTransaction(
    _contractURI: string,
    _controlCenter: string,
    _trustedForwarder: string,
    _nativeTokenWrapper: string,
    _saleRecipient: string,
    _royaltyBps: BigNumberish,
    _feeBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _contractURI,
      _controlCenter,
      _trustedForwarder,
      _nativeTokenWrapper,
      _saleRecipient,
      _royaltyBps,
      _feeBps,
      overrides || {}
    );
  }
  attach(address: string): LazyMintERC1155 {
    return super.attach(address) as LazyMintERC1155;
  }
  connect(signer: Signer): LazyMintERC1155__factory {
    return super.connect(signer) as LazyMintERC1155__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LazyMintERC1155Interface {
    return new utils.Interface(_abi) as LazyMintERC1155Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LazyMintERC1155 {
    return new Contract(address, _abi, signerOrProvider) as LazyMintERC1155;
  }
}
